module.exports = __webpack_public_path__ + "img/moneoverlay.9f1f9286.png";